export const ColorPickerPlatfromColors = [
  '#04608E', '#2D8F61', '#A77322', '#A04244', '#2B2F94', '#934732', '#0C0D11',
  '#008FD4', '#40D88E', '#FFAC2C', '#F36060', '#5244B3', '#DF6844', '#9499AA',
  '#99D2EE', '#B3EFD2', '#FFDEAB', '#FABFBF', '#BAB4E1', '#F2C3B4', '#D4D6DD'
];

export const ColorType = {
  Primary: 1,
  Custom: 2
}